requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xLanguageSelector', {
      enabled: false,
      currentSelected: '',
      currentLanguage: '',
      currentCountry: '',
      opened: '',
      selectedLanguage: localStorage.getItem('selectedLanguage') || '',
      selectedCountry: localStorage.getItem('selectedCountry') || '',
      show: false,

      initLanguageSelector(enabled) {
        this.enabled = enabled;
        this.currentSelected = this.selectedLanguage;
        this.currentLanguage = this.selectedLanguage;
        this.currentCountry = this.selectedCountry;
      },
      
      close() {
        this.show = false;
        document.body.style.overflow = 'auto';
      },
      
      open() {
        this.show = true;
        document.body.style.overflow = 'hidden';
        if (this.selectedLanguage !== '') {
          this.currentSelected = this.selectedLanguage;
        }
      },

      setCurrentSelected(selection) {
        this.currentSelected = selection;
        this.opened = selection;
      },

      setLanguage(language) {
        this.currentLanguage = language;
      },

      setCountry(country) {
        this.currentCountry = country;
      },

      getLanguage() {
        if (this.selectedLanguage !== '') {
          return this.selectedLanguage.match(/^(.*)-(\d+)$/)[1];
        }
      },

      getCountry() {
        if (this.selectedCountry !== '') {
          return this.selectedCountry.match(/^(.*)-(\d+)$/)[1];
        }
      },

      getLanguageText() {
        if (this.selectedLanguage !== '') {
          const parser = new DOMParser();
          const decodedString = parser.parseFromString(this.selectedLanguage.match(/^(.*)-(\d+)$/)[1], 'text/html').body.textContent || "";
          return decodedString;  
        }
      },

      getCountryText() {
        if (this.selectedCountry !== '') {
          const parser = new DOMParser();
          const decodedString = parser.parseFromString(this.selectedCountry.match(/^(.*)-(\d+)$/)[1], 'text/html').body.textContent || "";
          return decodedString;  
        }
      },

      checkSelection(languageList) {
        if (this.selectedLanguage !== '') {
          let inSelection = false;
          languageList.forEach(language => {
            if (language === this.selectedLanguage) inSelection = true;
          });
          if (!inSelection && languageList.length > 0) {
            this.selectedLanguage = languageList[0];
          }
        }
      },

      setSelectedLanguage(sectionId) {
        if (this.currentLanguage) {
          this.selectedLanguage = this.currentLanguage;
          localStorage.setItem('selectedLanguage', this.selectedLanguage);
          
          // Update button text
          const languageElement = document.querySelector('#language-selector-name-' + sectionId);
          if (languageElement) {
            languageElement.innerHTML = this.getLanguage();
          }
          
          // Update language code in button
          const codeElement = document.querySelector('.language-selector-item span:first-child');
          if (codeElement && this.currentLanguage) {
            const languageCode = this.getLanguageCode(this.currentLanguage);
            codeElement.innerHTML = languageCode.toUpperCase();
          }
        }

        if (this.currentCountry) {
          this.selectedCountry = this.currentCountry;
          localStorage.setItem('selectedCountry', this.selectedCountry);
        }

        this.close();
        
        // Trigger custom event for language change
        window.dispatchEvent(new CustomEvent('languageChanged', {
          detail: {
            language: this.selectedLanguage,
            country: this.selectedCountry
          }
        }));
      },

      getLanguageCode(languageName) {
        // Extract language code from selection
        const match = languageName.match(/^(.*)-(\d+)$/);
        if (match) {
          const name = match[1].toLowerCase();
          // Simple mapping - you can expand this
          const codeMap = {
            'español': 'es',
            'english': 'en',
            'français': 'fr',
            'deutsch': 'de',
            'italiano': 'it',
            'português': 'pt'
          };
          return codeMap[name] || 'es';
        }
        return 'es';
      },

      // Handle select changes
      onLanguageChange(event, sectionId) {
        const selectedValue = event.target.value;
        const selectedText = event.target.options[event.target.selectedIndex].text;
        this.setLanguage(selectedText + '-1');
        
        // Update button immediately
        const codeElement = document.querySelector('.language-selector-item span:first-child');
        if (codeElement) {
          codeElement.innerHTML = selectedValue.toUpperCase();
        }
      },

      onCountryChange(event, sectionId) {
        const selectedValue = event.target.value;
        const selectedText = event.target.options[event.target.selectedIndex].text;
        this.setCountry(selectedText + '-1');
      },

      // Initialize button with stored values
      initButton(sectionId) {
        if (this.selectedLanguage) {
          const languageElement = document.querySelector('#language-selector-name-' + sectionId);
          if (languageElement) {
            languageElement.innerHTML = this.getLanguage();
          }
          
          const codeElement = document.querySelector('.language-selector-item span:first-child');
          if (codeElement) {
            const languageCode = this.getLanguageCode(this.selectedLanguage);
            codeElement.innerHTML = languageCode.toUpperCase();
          }
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Close modal on escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      Alpine.store('xLanguageSelector').close();
    }
  });

  // Handle form submissions if needed
  document.addEventListener('change', function(event) {
    if (event.target.matches('#language-selector select')) {
      // Handle select changes
      const sectionId = event.target.closest('[id*="LanguageSelector-"]')?.id.split('-')[1];
      if (event.target.name === 'language') {
        Alpine.store('xLanguageSelector').onLanguageChange(event, sectionId);
      } else if (event.target.name === 'country') {
        Alpine.store('xLanguageSelector').onCountryChange(event, sectionId);
      }
    }
  });
});
